export const AvatarStyle = {
  sizes: {
    md: {
      container: {
        '--avatar-size': '2.5rem',
      },
    },
    lg: {
      container: {
        '--avatar-size': '3.5rem',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'elevated',
  },
}
